// Gegenereerd bestand - NIET BEWERKEN!
// WEL inchecken in Git!

export enum PlanningStatus {
    PlanningBehoefte = 'planningBehoefte',
    PlanningGarantiewerk = 'planningGarantiewerk',
    PlanningGeblokkeerd = 'planningGeblokkeerd',
    PlanningGepland = 'planningGepland',
    PlanningRegen = 'planningRegen',
    PlanningReservering = 'planningReservering',
    PlanningSlaapdag = 'planningSlaapdag',
    PlanningVerwerkt = 'planningVerwerkt',
}
